import { render, staticRenderFns } from "./TaskPicker.vue?vue&type=template&id=2aa1d016&scoped=true"
import script from "./TaskPicker.vue?vue&type=script&lang=js"
export * from "./TaskPicker.vue?vue&type=script&lang=js"
import style0 from "./TaskPicker.vue?vue&type=style&index=0&id=2aa1d016&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa1d016",
  null
  
)

export default component.exports